module.exports = __webpack_public_path__ + "media/packs/user-cards/images/clear-062af48e18ae3d05640dcb7f4fecd7b1.svg";